import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonMenuButton,
  IonPage,
  IonTitle,
} from "@ionic/react";
import { useParams } from "react-router";
import ExploreContainer from "../ExploreContainer/ExploreContainer";
import "./Page.css";
//@ts-ignore
import { useEffect, useState } from "react";
import { useSession } from "../../hooks/SessionContext";
import { reloadOutline } from "ionicons/icons";

interface ContainerProps {}
//@ts-ignore
const Page: React.FC<ContainerProps> = () => {
  const [reloaded, setReloaded] = useState<boolean>(false);
  const { name } = useParams<{ name: string }>();
  const { hcUL } = useSession();

  useEffect(() => {
    if (!reloaded) setReloaded(true);
  }, [reloaded]);

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonCard>
          <IonItem lines="none">
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle slot="start">{name}</IonTitle>
            <IonButton
              fill="clear"
              color="dark"
              slot="end"
              onClick={() => setReloaded(false)}
            >
              <IonIcon icon={reloadOutline} slot="end" />
            </IonButton>
          </IonItem>
        </IonCard>
      </IonHeader>
      <IonContent fullscreen>
        {hcUL && reloaded && <ExploreContainer />}
      </IonContent>
    </IonPage>
  );
};
export default Page;
